module.exports = __webpack_public_path__ + "img/foot.a9c76d28.png";